module.exports = __webpack_public_path__ + "staticcomp/img/end.e420ac2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/end.png
// module id = hINi
// module chunks = 39